module.exports = __webpack_public_path__ + "static/img/img-cp3-1.058ec15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp3-1.png
// module id = +Sen
// module chunks = 0